import React, {useState} from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import {getText} from 'helpers/language-helper';
import {loginUiTexts} from 'data/ui-texts/login-ui-texts';
import {errorUiTexts} from 'data/ui-texts/error-ui-texts';
import Button from 'components/ui/button/button';
import './reset-password.scss';

const ResetPassword = ({languageId, setShowResetPassword}) => {
	const [isLoading, setIsLoading] = useState(false);
	const [passwordIsReset, setPasswordIsReset] = useState(false);
	const [email, setEmail] = useState('');
	const [feedback, setFeedback] = useState(null);

	/**
	 *  Update input field
	 */
	const handleInput = (event) => {
		let value = event.target.value;
		setEmail(value);
		setFeedback(null);
	};

	/** 
	 * Submit reset password request 
	 */
	const handleSubmit = () => {
		if (!email || email.length === 0) {
			setFeedback(getText(errorUiTexts.invalidEmail, languageId));
			return;
		}
		handleResetPassword(email);
	};

	/** 
	 * Reset password 
	 */
	const handleResetPassword = (email) => {
		setIsLoading(true);

		const auth = firebase.auth();
		auth.sendPasswordResetEmail(email).then(()=>{
			setIsLoading(false);
			setPasswordIsReset(true);
		}).catch((error) =>{
			console.error(error);
			setIsLoading(false);
			setFeedback(getText((errorUiTexts.unknownError, languageId)));
		});
	};

	if (passwordIsReset) {
		return (
			<div className="ResetPassword">
				<div className="ResetPassword-title">
					<span>{getText(loginUiTexts.resetPassword, languageId)}</span>
				</div>
				<div className="ResetPassword-body">
					<div className="ResetPassword-info">
						<span>{getText(loginUiTexts.passwordResetFeedback, languageId)}</span>
					</div>
					<div 
						className="ResetPassword-resetPasswordBtn"
						onClick={()=>{setShowResetPassword(false);}}
					><span>{getText(loginUiTexts.goToLoginBtn, languageId)}</span></div>
				</div>
			</div>
		);
	}

	return (
		<div className="ResetPassword">
			<div className="ResetPassword-title">
				<span>{getText(loginUiTexts.resetPassword, languageId)}</span>
			</div>
			<div className="ResetPassword-body">
				<form className="ResetPassword-form" onSubmit={handleSubmit}>
					<input
						name="email"
						type="text"
						placeholder={getText(loginUiTexts.email, languageId)}
						autoComplete="section-resetpasswrd email"
						value={email ? email : ''}
						onChange={(event)=>{handleInput(event);}}
					/>
					<Button
						isLoading={isLoading}
						classes={['login']}
						text={getText(loginUiTexts.reset, languageId)}
						onClick={() =>{handleSubmit();}}
					/>
					<p className="ResetPassword-errorMessage">
						<span>{feedback}</span>
					</p>
				</form>
				<div 
					className="ResetPassword-resetPasswordBtn"
					onClick={()=>{setShowResetPassword(false);}}
				><span>{getText(loginUiTexts.goToLoginBtn, languageId)}</span></div>
			</div>
		</div>
	);
};

ResetPassword.propTypes = {
	languageId: PropTypes.string.isRequired,
	setShowResetPassword: PropTypes.func.isRequired,
};

export default ResetPassword;